import { useState } from 'react';

import SingleQuoteDesktop from './SingleQuoteDesktop/index';
import useScreenWidth from './../../../../../hooks/useScreenWidth';
import SingleQuoteMobile from './SingleQuoteMobile';

interface ComponentProps {
  data: any;
  allQuotes: any[];
  setAllQuotes: (v: any[]) => void;
}
const SingleQuotes = ({ data, allQuotes, setAllQuotes }: ComponentProps) => {
  const [viewDetailsModalShow, setViewDetailsModalShow] =
    useState<boolean>(false);

  const screenWidth = useScreenWidth();

  return (
    <>
      {screenWidth > 576 ? (
        <SingleQuoteDesktop
          allQuotes={allQuotes}
          setAllQuotes={setAllQuotes}
          viewDetailsModalShow={viewDetailsModalShow}
          setViewDetailsModalShow={setViewDetailsModalShow}
          data={data}
        />
      ) : (
        <SingleQuoteMobile
          allQuotes={allQuotes}
          setAllQuotes={setAllQuotes}
          viewDetailsModalShow={viewDetailsModalShow}
          setViewDetailsModalShow={setViewDetailsModalShow}
          data={data}
        />
      )}
    </>
  );
};

export default SingleQuotes;
